module.exports = __webpack_public_path__ + "static/img/ico7.ff09f867.svg";